import React, { useCallback, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from 'store/hooks';
import { selectClientPortalCompanies } from 'store/ticketTemplates/selectors';
import { ThunkCreateTicket } from 'store/tickets/thunks';

import Input from 'components/Input/Input';
import Button from 'components/Button/Button';
import FormSelect from 'components/Select/FormSelect';

import { ICreateTicketInitialValues } from 'pages/CreateTicket/form';
import { TICKET } from 'router/routes';

import useStyles from '../styles';

interface IProps {
  onClose: () => void;
  onSuccess?: () => void;
  isConnectWise: boolean;
  notUserRole: boolean;
}

const TicketCreationDefaultForm: React.FC<IProps> = ({ onClose, onSuccess, isConnectWise, notUserRole }) => {
  const [processing, setProcessing] = useState<boolean>(false);

  const companyOptions = useSelector(selectClientPortalCompanies);
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    (values: ICreateTicketInitialValues) => {
      setProcessing(true);
      dispatch(ThunkCreateTicket({ payload: values }))
        .unwrap()
        .then(res => {
          if (onSuccess) {
            onSuccess();
          }
          onClose()
          navigate(TICKET.replace(':ticketId', res.data));
        })
        .finally(() => {
          setProcessing(false);
        });
    },
    [dispatch],
  );

  const formik = useFormik({
    initialValues: {
      title: '',
      description: '',
      companyId: '',
    },
    onSubmit: handleSubmit,
    validationSchema: Yup.object().shape({
      title: Yup.string().required(),
      description: Yup.string().required(),
    }),
  });

  return (
    <form onSubmit={formik.handleSubmit} className={classes.templateBody}>
      {isConnectWise && notUserRole && !!companyOptions.length && (
        <FormSelect
          formik={formik}
          name="companyId"
          label="Select Customer"
          defaultValue=""
          options={companyOptions}
        />
      )}
      <Input label="Summary" name="title" formik={formik} disabled={processing} />
      <Input
        label="Description"
        name="description"
        formik={formik}
        multiline
        minRows={4}
        disabled={processing}
      />

      <div className={classes.buttonsContainer}>
        <Button text="Close" onClick={onClose} disabled={processing} />
        <Button text="Create" type="submit" disabled={processing} loading={processing} />
      </div>
    </form>
  );
};

export default TicketCreationDefaultForm;
